export default __webpack_public_path__ + "static/flag-cambodia-c4b762e5395019fa389e36cdff121e8d.svg";